import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-simple-layout',
  templateUrl: './simple-layout.component.html',
  styleUrls: ['./simple-layout.component.scss'],
})
export class SimpleLayoutComponent {
  @Input() showSaveButton = false;
  @Input() saveBtnText = 'BUTTONS.save';
  @Input() headerTitle: string;
  @Input() backPath: any[];
  @Input() skeletonLoad = false;
  /**
   * * Outputs
   * @handleSubmit Event when user click SAVE
   */
  @Output() handleSubmit = new EventEmitter<any>();

  /* ====================================
  *             MAIN FEATURES
  ======================================= */

  onSubmitForm() {
    this.handleSubmit.emit(true);
  }
}
